import React from "react";
import RoutesComponentProps from "./RoutesComponentProps";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import routes, { RouteEntity } from "./Routes";

const RoutesComponent: React.FC<RoutesComponentProps> = ({ children }) => {
    return (
        <BrowserRouter>
            <Routes>
                {Object.values(routes).map((route: RouteEntity) => (
                    <Route 
                        key={route.path} 
                        path={route.path} 
                        element={React.createElement(route.component, {}, undefined)} 
                    />
                ))}
            </Routes>
        </BrowserRouter>
    );
}

export default RoutesComponent;
export { RoutesComponent };
